import { render, staticRenderFns } from "./MemberOtoCommunication.vue?vue&type=template&id=6aabb9f8&scoped=true&"
import script from "./MemberOtoCommunication.vue?vue&type=script&lang=js&"
export * from "./MemberOtoCommunication.vue?vue&type=script&lang=js&"
import style0 from "./MemberOtoCommunication.vue?vue&type=style&index=0&id=6aabb9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aabb9f8",
  null
  
)

export default component.exports